export const UrlOpenTypes = [
    { label: "Open URL (New Window)", value: "OpenNewWindow" },
    { label: "Open URL (Inside Compendium)", value: "OpenInside" },
    { label: "Open Content Item", value: "OpenContentItem" },
];